import { Box, Tabs, TabList, TabPanels, TabPanel } from '@chakra-ui/react';
import dynamic from 'next/dynamic';
import { FormTabs as Props, MhyChakraProps } from '../../types';
import HtmlContent from '../HtmlContent';
import Tab from '../Tab';

const Form = dynamic(() => import('../Forms'));

const FormTabs = ({
  tabs,
  ...rest
}: { tabs: Props } & Omit<MhyChakraProps, 'variant'>) => (
  <Box bg="gray1" borderRadius="lg" p={10} {...rest}>
    <Tabs size="lg">
      <TabList borderBottom="none" mb={5} overflowX="auto">
        {tabs?.map(({ title }, i) => (
          <Tab key={title} data-test-id={`form-tab-button-${i + 1}`}>
            {title}
          </Tab>
        ))}
      </TabList>
      <TabPanels>
        {tabs?.map(({ title, wysiwyg, form }, i) => (
          <TabPanel px={0} key={title} data-test-id={`form-tab-panel-${i + 1}`}>
            {wysiwyg && <HtmlContent html={wysiwyg} />}
            {form && <Form {...form} />}
          </TabPanel>
        ))}
      </TabPanels>
    </Tabs>
  </Box>
);

export default FormTabs;
